import { useState, useEffect } from 'react';
import { getCurrentUser, getUserEnrollments } from '@/lib/api';

/**
 * Hook to get the current user's product enrollments.
 * Returns an array of product IDs the user is enrolled in.
 */
export const useUserEnrollments = () => {
  const [enrolledProducts, setEnrolledProducts] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchEnrollments = async () => {
      try {
        const userResult = await getCurrentUser();
        if (!userResult.success || !userResult.data) {
          setEnrolledProducts([]);
          setLoading(false);
          return;
        }

        const enrollmentsResult = await getUserEnrollments(userResult.data.id);
        if (enrollmentsResult.success && enrollmentsResult.data) {
          const activeProducts = enrollmentsResult.data
            .filter((e: any) => e.is_active)
            .map((e: any) => e.product_id);
          setEnrolledProducts(activeProducts);
        } else {
          setEnrolledProducts([]);
        }
      } catch (err) {
        console.error('Error fetching enrollments:', err);
        setError(err instanceof Error ? err : new Error('Unknown error'));
        setEnrolledProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEnrollments();
  }, []);

  return { enrolledProducts, loading, error };
};
